import api from './api';

export type PublicInventoryItem = {
  shortId: string;
  displayName: string;
  sizeValue: number | null;
  sizeUnit: string | null;
  /** Retail price in minor units (cents); null when unset. */
  salePrice: number | null;
  salePriceCurrency: string | null;
  wine: {
    wineName: string | null;
    displayVintage: string | null;
    producer: string | null;
    region: string | null;
    /** Country-first → leaf region path, e.g. "United States / Oregon / Willamette Valley". */
    regionPath: string | null;
    country: string | null;
    color: string | null;
  } | null;
  /** Venue branding for template rendering (from the Main-API-owned venue). */
  venue: {
    name: string | null;
    logoUrl: string | null;
  } | null;
  /** Active per-venue QR landing template, when configured. */
  qrLandingTemplate: {
    html: string;
    isActive: boolean;
  } | null;
};

const inventoryItemPublicService = {
  getByShortId(shortId: string): Promise<PublicInventoryItem> {
    return api
      .get<PublicInventoryItem>(
        `/public/inventory-item/by-short-id/${encodeURIComponent(shortId)}`
      )
      .then((r) => r.data);
  },
};

export default inventoryItemPublicService;
